
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=first_name,last_name,email' : ''
    // pagination
    const page = data.page ? data.page : 1
    return axios.get(process.env.API_ENDPOINT + '/user?token=' + VueCookies.get('token') + '&page=' + page + search + limit)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/user/invite?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/user/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/user/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/user/' + id + '?token=' + VueCookies.get('token'))
  },
  getTeachers (data) {
    const includeInactive = (data && data.include_inactive) ? '&include_inactive=' + data.include_inactive : '&include_inactive=0'
    return axios.get(process.env.API_ENDPOINT + '/user/teachers?token=' + VueCookies.get('token') + includeInactive)
  },
  createUserFromInvitation (data) {
    return axios.post(process.env.API_ENDPOINT + '/register-user-by-invite?code=' + data.code + '&token=' + VueCookies.get('token'), data.data)
  },
  getTeacherDirectory (data) {
    const page = data.page ? data.page : 1
    const limit = data.limit ? '&limit=' + data.limit : ''
    const search = data.search ? '&s=' + data.search + '&s_field=first_name,last_name,email' : ''
    return axios.get(process.env.API_ENDPOINT + '/user/teachers?token=' + VueCookies.get('token') + '&page=' + page + limit + search)
  }
}



// WEBPACK FOOTER //
// ./src/store/api/users.js